import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "💨", key: "wontStay" },
  { emoji: "📷", key: "photosFlat" },
  { emoji: "🙈", key: "neverLooks" },
  { emoji: "😕", key: "noTools" },
]

export default function PetsBiggestPainPage() {
  return (
    <RadioCardListPage translationKey="petsBiggestPain" options={OPTIONS} />
  )
}
